import React from "react";
import { ButtonWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import Button from "../../../../shared/button/button";

function NavButton({
  showPrevButton = false,
  handleNext = null,
  handlePrev = null,
  disabled = false,
  prevDisabled = false,
  nextText,
}) {
  const { t } = useTranslation();
  return (
    <ButtonWrapper>
      {showPrevButton ? (
        <Button
          type="button"
          variant={prevDisabled ? "disabled" : "inherit"}
          disabled={prevDisabled}
          onClick={handlePrev}
        >
          {t("prev")}
        </Button>
      ) : null}
      <Button
        type="submit"
        disabled={disabled}
        variant={disabled ? "disabled" : "primary"}
        onClick={handleNext}
      >
        {nextText || t("next")}
      </Button>
    </ButtonWrapper>
  );
}

export default NavButton;
